var tagalysDisableLegacyScript = true;

  function setTagalysConfiguration() {
    Tagalys.setConfiguration({
      api: {
        serverUrl: "https://api-r4.tagalys.com",
        credentials: {
          clientCode: "809EC093DD9811FC",
          apiKey: "88f4812755c088be18cac8725cb6b70b",
        },
        storeId: "48788340899",
      },
      platform: "Shopify", 
      locale: "en-GB", 
     
      currency: {
        displayFormatter: "{{currencyLabel}} {{value}}", 
        code: "EUR",
        label: "£", 
        fractionalDigits: 2, 
        forceFractionalDigits: true,
        
      },
			analyticsStorageConsentProvided: function(){
				
		    return true
		  },
		  track: true
    });
  }

  function onTagalysReady(callback) {
    if (window.Tagalys) {
      setTagalysConfiguration()
      callback()
    } else {
      window.addEventListener("DOMContentLoaded", function () {
        setTagalysConfiguration()
        callback()
      })
    }
  }

  onTagalysReady(function(){
    Tagalys.Analytics.trackPlatformEvents()
  })
